import { render, staticRenderFns } from "./modal-add-user.vue?vue&type=template&id=1013b9c8&scoped=true&lang=pug"
import script from "./modal-add-user.js?vue&type=script&lang=js&external"
export * from "./modal-add-user.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-user.vue?vue&type=style&index=0&id=1013b9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013b9c8",
  null
  
)

export default component.exports